// extracted by mini-css-extract-plugin
module.exports = {"ProfileRing":"ProfileRing_ProfileRing__2zWXL","blue":"ProfileRing_blue__3lHdO","green":"ProfileRing_green__1O1Kp","black":"ProfileRing_black__27q7S"};